module.exports = __webpack_public_path__ + "static/media/sarthak_pawar.b7dcb3ea.png";